var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildFriendlyVenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    stroke: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3979 17.5379L15.1522 14.0392C14.1562 13.5583 13 14.284 13 15.39V35.4328C13 36.0039 13.3243 36.5255 13.8366 36.7781L22.3979 41M22.3979 17.5379L31.7958 13M22.3979 17.5379V41M31.7958 13L40.1633 17.1254C40.6756 17.378 41 17.8996 41 18.4708V38.6556C41 39.7503 39.8653 40.4763 38.8714 40.0175L31.7958 36.7517M31.7958 13V36.7517M31.7958 36.7517L22.3979 41",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildFriendlyVenue);
export default __webpack_public_path__ + "static/media/child_friendly_venue.fc484ed306cf4daafca5d42c7591f23b.svg";
export { ForwardRef as ReactComponent };